<template>
    <TheModal class="sm" @close="close">
        <template slot="head">
            {{ $route.meta.title }}
            <a target="_blank" :href="getKBLink('add_product')" class="btn btn-link text-nowrap ml-2 px-0"><i class="tlm-icon-question-circle" /></a>
        </template>

        <ValidationObserver ref="obs" v-slot="{ invalid }" tag="form" class="form-thin" @submit.prevent="submit">
            <ValidationProvider v-errors.api vid="name" tag="div" class="form-group" rules="required|max:200">
                <input v-model="form.name" v-focus type="text" class="form-control" maxlength="60" placeholder="Введите название">
            </ValidationProvider>

            <ValidationProvider v-if="hasCrt" v-errors.api vid="vat" tag="div" class="form-group" rules="required">
                <select-vat v-model="form.vat" type="text" class="form-control" />
            </ValidationProvider>

            <ValidationProvider v-if="hasGtin" v-errors.api vid="gtin" tag="div" class="form-group" :rules="{ regex: /^0{0,6}[1-9][0-9]{7,13}$/ }">
                <input v-model="form.gtin" type="text" class="form-control" maxlength="14" placeholder="GTIN">
            </ValidationProvider>

            <div class="mt-4">
                <button type="submit" class="btn btn-primary btn-lg">{{ form.id ? 'Сохранить' : 'Создать' }}</button>
            </div>
        </ValidationObserver>
    </TheModal>
</template>

<script>
import store from '@/store'
import SelectVat from '@/components/SelectVat'
import TheModal from '@/components/TheModal'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { mixinApiErrors } from '@/validation'

import { toastSuccess } from '@/dialogs'
import cloneDeep from 'lodash/cloneDeep'

import KBLinksService from '@/services/KBLinksService'

export default {
    components: {
        SelectVat,
        TheModal,
        ValidationObserver,
        ValidationProvider
    },

    data() {
        return {
            form: {
                id: null,
                name: null,
                vat: null,
                gtin: null
            }
        }
    },

    computed: {
        hasCrt() {
            return this.$store.getters['company/hasCrt']
        },

        hasGtin() {
            return this.$store.getters['company/hasGtin']
        }
    },

    methods: {
        close() {
            this.$router.push({ name: 'stocks.products' })
        },

        async submit() {
            const isValid = await this.$refs.obs.validate()

            if (!isValid) {
                return
            }

            const done = await this.$store.dispatch('stocks/store', { ...this.form, is_composite: false })

            if (done) {
                this.close()
                toastSuccess(this.form.id ? 'Продукт сохранен' : 'Продукт создан')
            } else {
                mixinApiErrors(this.$refs.obs, this.$store.state.stocks.error)
            }
        },

        getKBLink(key) {
            return KBLinksService.get(key)
        }
    },

    async beforeRouteEnter(to, from, next) {
        if (!to.params.id) {
            return next()
        }

        const product = await store.dispatch('stocks/fetchById', parseInt(to.params.id))

        if (product) {
            return next(vm => {
                vm.form = cloneDeep(product)
            })
        }

        return next({ name: 'stocks.products' })
    }
}
</script>
